<!--
 * @Description: 云途商机详情
 * @Author: zz
-->
<template>
  <a-form scrollToFirstError :model="dataForm" ref="formRef">
    <dc-layout-card :title="props.title" :span="6">
      <dc-form-item label="客户名称" name="saleChanceRefId" :rules="formRules.saleChanceRefId">
        <ClueAndCustomerSelect
            appId="cos_lbu"
            v-model:value="dataForm.saleChanceRefId"
            v-model:label="dataForm.customerName"
            :disabled="!isEdit || props.saleChanceRefId"
            view
            placeholder="请选择客户名称"
        />
      </dc-form-item>
      <dc-form-item  label="始发地国家">
        <CustomerArea
          v-model:value="dataForm.originCountry"
          change-on-select
          showSearch
          :disabled="!isEdit"
          :display-level="1"
          view
          allowClear
        />
      </dc-form-item>
      <dc-form-item label="联系人姓名">
        <CosInput v-model:value="dataForm.contactName" view />
      </dc-form-item>
      <dc-form-item label="手机号">
        <CosInput v-model:value="dataForm.contactMobile" view />
      </dc-form-item>
      <dc-form-item label="客户归属区域" name="warehouseAttribution" :rules="formRules.warehouseAttribution">
        <ParamCodeCascader
            v-model:label="dataForm.warehouseAttributionName"
            v-model:value="dataForm.warehouseAttribution"
            :options="paramCodeData.lbu_warehouse_city"
            :disabled="!isEdit"
            view
        />
      </dc-form-item>
      <dc-form-item label="商机状态" name="status" :rules="formRules.status">
        <template #label>
          商机状态
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '900px' }">
            <template #title>
              <div v-for="item in businessStatusEnumFilter" :key="item.value">
                <p>{{ item.label }}{{ item.desc ? `：${item.desc}` : '' }}</p>
              </div>
            </template>
            <ExclamationCircleOutlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosSelect
            v-model:value="dataForm.status"
            :options="businessStatusEnumFilter"
            :disabled="!isEdit"
            view
            allowClear
        />
      </dc-form-item>
      <dc-form-item label="商机类型" name="saleChanceType" :rules="formRules.saleChanceType">
        <ParamCodesSelect
            v-model:value="dataForm.saleChanceType"
            :options="paramCodeData.lbu_sale_chance_type"
            :disabled="!isEdit"
            view
            allowClear
            :max-tag-count="!isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item label="竞争对手" name="competitors" :rules="formRules.competitors">
        <ParamCodesSelect
            v-model:value="dataForm.competitors"
            :options="paramCodeData.lbu_logistics_service_provider"
            :disabled="!isEdit"
            view
            allowClear
            mode="multiple"
            :max-tag-count="!isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item label="协助部门" name="assistDepartment">
        <ParamCodesSelect
            v-model:value="dataForm.assistDepartment"
            :options="paramCodeData.lbu_assistance_department"
            :disabled="!isEdit"
            view
            allowClear
        />
      </dc-form-item>
      <dc-form-item label="客户ID">
        <CosInput v-model:value="dataForm.saleChanceRefId" view />
      </dc-form-item>
      <dc-form-item label="商机名称">
        <CosInput v-model:value="dataForm.saleChanceNameByTxt" view />
      </dc-form-item>
      <dc-form-item label="商机ID">
        <CosInput v-model:value="dataForm.id" view />
      </dc-form-item>
      <dc-form-item label="客户负责人">
        <CosInput v-model:value="dataForm.dutyByName" view />
      </dc-form-item>
      <dc-form-item label="创建人">
        <CosInput v-model:value="dataForm.createByName" view />
      </dc-form-item>
      <dc-form-item label="创建时间">
        <CosInput v-model:value="dataForm.createTime" view />
      </dc-form-item>
      <dc-form-item label="更新人">
        <CosInput v-model:value="dataForm.updateByName" view />
      </dc-form-item>
      <dc-form-item label="更新时间">
        <CosInput v-model:value="dataForm.updateTime" view />
      </dc-form-item>
      <dc-form-item
          label="未能合作原因"
          name="failedCooperateId"
          :rules="formRules.failedCooperateId"
          v-if="isFailedCooperation"
      >
        <ParamCodesSelect
            v-model:value="dataForm.failedCooperateId"
            :options="paramCodeData.lbu_failure_reason"
            :disabled="!isEdit"
            view
            allowClear
        />
      </dc-form-item>
      <dc-form-item label="经营模式" name="managementModel" class="form-item_compact">
        <a-input-group compact class="cos-view-input-group">
          <ParamCodeCascader
            v-model:value="dataForm.managementModel"
            :cosDes="dataForm.managementModelExplain"
            appId="cos_lbu"
            paramCode="lbu_management_model"
            :status="props.type === 'view' ? undefined : 0"
            :disabled="!isEdit"
            view
            style="width: 33%"
          />
          <dc-form-item name="managementModelExplain" :span="24" style="width: 67%" class="last-compact">
            <CosInput
              v-model:value="dataForm.managementModelExplain"
              :maxlength="100"
              :disabled="!isEdit"
              view
            />
          </dc-form-item>
        </a-input-group>
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card title="现有发货量（ER/元）" :span="6">
      <dc-form-item label="目的地国家" name="requiredCountry" :rules="formRules.requiredCountry">
        <ParamCodesSelect
            v-model:value="dataForm.requiredCountry"
            :options="paramCodeData.lbu_demand_country"
            :disabled="!isEdit"
            view
            allowClear
            @change="handleCountryChange"
        />
      </dc-form-item>
      <dc-form-item label="云途产品" name="product" :rules="formRules.product">
        <ParamCodeCascader
          v-model:value="dataForm.product"
          :options="paramCodeData.lbu_products"
          view
          allowClear
        />
      </dc-form-item>
      <dc-form-item label="当前账号上月发货票数">
        <CosInputNumber
            v-model:value="dataForm.ctUitQty"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
        />
      </dc-form-item>
      <dc-form-item label="当前账号去年上月发货票数">
        <CosInputNumber
            v-model:value="dataForm.ctLyUitQty"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
        />
      </dc-form-item>
      <dc-form-item label="当前账号前三个月平均发货票数">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>不含上个月，即前第2到第4个月</p>
            </template>
            <span>当前账号前三个月平均发货票数</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosInputNumber
            v-model:value="dataForm.ctMarQty"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
        />
      </dc-form-item>
      <dc-form-item label="当前账号发货量状态">
        <CosInput
            v-model:value="dataForm.ctQtyStatus"
            view
        />
      </dc-form-item>
      <dc-form-item label="主账号上月发货票数">
        <CosInputNumber
            v-model:value="dataForm.uitQty"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
        />
      </dc-form-item>
      <dc-form-item label="主账号去年上月发货票数">
        <CosInputNumber
            v-model:value="dataForm.lyUitQty"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
        />
      </dc-form-item>
      <dc-form-item label="主账号前三个月平均发货票数">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>不含上个月，即前第2到第4个月</p>
            </template>
            <span>主账号前三个月平均发货票数</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosInputNumber
            v-model:value="dataForm.marQty"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
        />
      </dc-form-item>
      <dc-form-item label="主账号发货量状态">
        <CosInput
            v-model:value="dataForm.qtyStatus"
            view
        />
      </dc-form-item>
      <template v-if="dataForm.status === 5 || dataForm.status === 7">
        <dc-form-item label="当月新增收入（元）">
          <CosInputNumber v-model:value="dataForm.cmAdd" view cos-type="money"/>
        </dc-form-item>
        <dc-form-item label="收入环比增长（元）">
          <CosInputNumber v-model:value="dataForm.hGrowth" view cos-type="money"/>
        </dc-form-item>
        <dc-form-item label="FTB首月收入（元）">
          <CosInputNumber v-model:value="dataForm.ftbCm" view cos-type="money"/>
        </dc-form-item>
        <dc-form-item label="FTB客户承诺收入（元）">
          <CosInputNumber v-model:value="dataForm.ftbCurPro" view cos-type="money"/>
        </dc-form-item>
      </template>
    </dc-layout-card>
    <dc-layout-card title="潜力信息" :span="6">
      <dc-form-item label="OPR票数" name="mau" :rules="formRules.mau">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>潜力月均发货量</p>
            </template>
            <span>OPR票数</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <!--        <CosTextarea v-model:value="dataForm.mau" :maxlength="2000" :disabled="!isEdit" view />-->
        <CosInputNumber
            style="width: 100%"
            :min="0"
            :maxlength="15"
            cos-type="money"
            v-model:value="dataForm.mau"
            :disabled="!isEdit"
            placeholder="请输入OPR票数"
            view
            oninput="value= value.length === 1 ? value.replace(/[^1-9]/g,''):value.replace(/[^\d]/g,'')"
        />
      </dc-form-item>
      <dc-form-item label="OPR金额" name="planSaleAmount" :rules="formRules.planSaleAmount">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>潜力月均销售额(元)</p>
            </template>
            <span>OPR金额</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosInputNumber
            style="width: 100%"
            :min="0"
            :maxlength="15"
            cos-type="money"
            v-model:value="dataForm.planSaleAmount"
            :disabled="!isEdit"
            oninput="value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
            placeholder="对应仓库及渠道的OPR金额"
            view
        />
      </dc-form-item>
      <dc-form-item label="OCR票数" name="committedShipment" :rules="formRules.committedShipment">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>客户承诺月均发货量</p>
            </template>
            <span>OCR票数</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <!--        <CosTextarea v-model:value="dataForm.mau" :maxlength="2000" :disabled="!isEdit" view />-->
        <CosInputNumber
            style="width: 100%"
            :min="0"
            :maxlength="15"
            cos-type="money"
            v-model:value="dataForm.committedShipment"
            :disabled="!isEdit"
            placeholder="请输入OCR票数"
            view
            oninput="value= value.length === 1 ? value.replace(/[^1-9]/g,''):value.replace(/[^\d]/g,'')"
        />
      </dc-form-item>
      <dc-form-item label="OCR金额" name="committedSaleAmount" :rules="formRules.committedSaleAmount">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>客户承诺月均销售额（元）</p>
            </template>
            <span>OCR金额</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <!--        <CosTextarea v-model:value="dataForm.mau" :maxlength="2000" :disabled="!isEdit" view />-->
        <CosInputNumber
            style="width: 100%"
            :min="0"
            :maxlength="15"
            cos-type="money"
            v-model:value="dataForm.committedSaleAmount"
            :disabled="!isEdit"
            placeholder="请输入OCR金额"
            view
            oninput="value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
        />
      </dc-form-item>
      <template v-if="isB2BProduct">
        <dc-form-item label="OPR重量（KG）" name="oprWeight" :rules="formRules.required">
          <CosInputNumber
            style="width: 100%"
            :min="0"
            :maxlength="15"
            cos-type="money"
            v-model:value="dataForm.oprWeight"
            :disabled="!isEdit"
            placeholder="请输入"
            view
            oninput="value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
          />
        </dc-form-item>
        <dc-form-item label="OCR重量（KG）" name="ocrWeight" :rules="isRequired ? formRules.required : undefined">
          <CosInputNumber
            style="width: 100%"
            :min="0"
            :maxlength="15"
            cos-type="money"
            v-model:value="dataForm.ocrWeight"
            :disabled="!isEdit"
            placeholder="请输入"
            view
            oninput="value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
          />
        </dc-form-item>
        <dc-form-item label="OPR方数（m³）" name="oprCube">
          <CosInputNumber
            style="width: 100%"
            :min="0"
            :maxlength="15"
            cos-type="money"
            v-model:value="dataForm.oprCube"
            :disabled="!isEdit"
            placeholder="请输入"
            view
            oninput="value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
          />
        </dc-form-item>
        <dc-form-item label="OCR方数（m³）" name="ocrCube">
          <CosInputNumber
            style="width: 100%"
            :min="0"
            :maxlength="15"
            cos-type="money"
            v-model:value="dataForm.ocrCube"
            :disabled="!isEdit"
            placeholder="请输入"
            view
            oninput="value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
          />
        </dc-form-item>
        <dc-form-item label="发货频次（次/月）" name="shipmentFrequency">
          <CosInputNumber
            style="width: 100%"
            :min="0"
            :maxlength="15"
            cos-type="money"
            v-model:value="dataForm.shipmentFrequency"
            :disabled="!isEdit"
            placeholder="请输入发货频次"
            view
            oninput="value=value.length === 1 ? value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
          />
        </dc-form-item>
        <dc-form-item label="货物类型" name="goodsCategory" :rules="formRules.goodsCategory">
          <ParamCodesSelect
            v-model:value="dataForm.goodsCategory"
            :options="paramCodeData.lbu_sales_category"
            :disabled="!isEdit"
            view
            allowClear
            mode="multiple"
            :max-tag-count="!isEdit ? 100 : 'responsive'"
          />
        </dc-form-item>
      </template>

      <a-col :span="24" />
      <dc-form-item label="竞对情况" name="competitionSituation" :span="12" :rules="formRules.competitionSituation">
        <CosTextarea
            v-model:value="dataForm.competitionSituation"
            :maxlength="2000"
            :disabled="!isEdit"
            placeholder="描述竞争对手所释放给该客户的具体价格，账期或其他活动策略，转运时间，货量要求等"
            view
        />
      </dc-form-item>
      <dc-form-item label="客户情况" name="customerSituation" :span="12" :rules="formRules.customerSituation">
        <CosTextarea
            v-model:value="dataForm.customerSituation"
            :maxlength="2000"
            :disabled="!isEdit"
            placeholder="客户的营业模式，最近一次沟通和拜访的情况和进度，遇到的问题"
            view
        />
      </dc-form-item>
      <dc-form-item label="所需支持" name="requiredSupport" :span="12">
        <CosTextarea
            v-model:value="dataForm.requiredSupport"
            :maxlength="2000"
            :disabled="!isEdit"
            placeholder="针对客户商机转换所需要的支持和帮助内容"
            view
        />
      </dc-form-item>
      <dc-form-item label="备注" name="remark" :span="12" :rules="formRules.remark">
        <CosTextarea
            v-model:value="dataForm.remark"
            :maxlength="2000"
            :disabled="!isEdit"
            placeholder="其他需要特殊说明的内容，客户货品重量情况等"
            view
        />
      </dc-form-item>
    </dc-layout-card>
  </a-form>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted, watch, computed } from 'vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { Form } from 'ant-design-vue'
import { businessStatusEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import { countryChannelRelevance } from '@/api/yuntuSales/operationsManage'
import { listByParamCodes } from '@/api/common'
import { selectForNumberValidate } from '@/utils/validate'
import { paramCodesDataFilter, findByIdDeep } from '@/utils/index'
import type { ParamCodeItem } from '@/typings/common'
import type { LbuBusinessEditParams } from '@/typings/api/chanceManage'
import CosInput from '@/components/Antd/CosInput/index.vue'
import CustomerArea from '@/components/CustomerArea'

const useForm = Form.useForm
const formRef = ref()
const props = defineProps<{
  value: { [key: string]: any }
  title?: string
  type: 'add' | 'edit' | 'view'
  originalStatus?:number
  saleChanceRefId?: boolean
}>()
const businessStatusEnumFilter = ref<any[]>()
const isEdit = computed(() => props.type !== 'view')
const paramCodeData = ref<{
  lbu_demand_country: ParamCodeItem[]
  lbu_products: ParamCodeItem[]
  lbu_warehouse_city: ParamCodeItem[]
  lbu_logistics_service_provider: ParamCodeItem[]
  lbu_assistance_department: ParamCodeItem[]
  lbu_failure_reason: ParamCodeItem[]
  lbu_sale_chance_type: ParamCodeItem[]
  lbu_sales_category: ParamCodeItem[],
  lbu_shipping_channel: ParamCodeItem[],
}>({
  lbu_demand_country: [], // 目的地国家（需求国家）
  lbu_products: [], // 出货渠道（云途产品）
  lbu_warehouse_city: [], // 客户归属区域
  lbu_logistics_service_provider: [], // 竞争对手
  lbu_assistance_department: [], // 协助部门
  lbu_failure_reason: [], // 未能合作原因
  lbu_sale_chance_type: [], // 云途商机类型
  lbu_sales_category: [],
  lbu_shipping_channel: []
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: [
      'lbu_demand_country',
      'lbu_products',
      'lbu_warehouse_city',
      'lbu_logistics_service_provider',
      'lbu_assistance_department',
      'lbu_failure_reason',
      'lbu_sale_chance_type',
      'lbu_sales_category',
      'lbu_shipping_channel'
    ]
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    paramCodeData.value = res.data
  })
}

const isB2BProduct = computed(() => {
  const findOne = findByIdDeep(paramCodeData.value.lbu_products, dataForm.value.product)
  return findOne?.comment?.toUpperCase().includes('B2B') === true
})

onMounted(() => {
  if (props.type === 'add') {
    businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === 0)
    dataForm.value.status = 0
  }
  getByParamCodes()
})

const dataForm = ref<LbuBusinessEditParams>({})

const emit = defineEmits(['update:value'])
watch(
  () => props.value,
  (val) => {
    if (!val) return
    dataForm.value = val
  },
  { deep: true, immediate: true }
)
watch(
  dataForm,
  (val) => {
    emit('update:value', val)
  },
  { deep: true }
)
// 根据“目的地国家（需求国家）”的变化获取“出货渠道”
const shippingChannel = ref<ParamCodeItem[]>([])
const getShippingChannel = (val: number) => {
  const params = { paramId: val }
  countryChannelRelevance(params).then((res) => {
    shippingChannel.value = res.data
  })
}
watch(
  () => dataForm.value.requiredCountry,
  (newVal) => {
    if (newVal && newVal !== -9) {
      getShippingChannel(newVal)
    }
  }
)
const handleCountryChange = (val?: number) => {
  dataForm.value.product = undefined
  shippingChannel.value = []
}

const isFailedCooperation = ref(false)
// 客户承诺月均发货量（OCR票数） 客户承诺月均销售额（OCR金额）在商机状态变为【签约】、【准备发件】、【首次发件】、【达到承诺业务量】时，必填
const isRequired = ref(false)
const formRules = reactive({
  saleChanceRefId: [{ required: true, message: '请选择客户名称' }],
  planSaleAmount: [{ required: true && props.type !== 'view', message: '请输入OPR金额' }],
  status: [{ required: true, validator: selectForNumberValidate, message: '请选择商机状态' }],
  requiredCountry: [{ required: true, validator: selectForNumberValidate, message: '请选择目的地国家' }],
  product: [{ required: true, validator: selectForNumberValidate, message: '请选择云途产品' }],
  warehouseAttribution: [{ required: true, message: '请选择客户归属区域' }],
  competitors: [{ required: true, message: '请选择竞争对手' }],
  saleChanceType: [{ required: true, message: '请选择商机类型' }],
  failedCooperateId: [
    { required: isFailedCooperation, validator: selectForNumberValidate, message: '请选择未能合作原因' }
  ],
  remark: [{ required: isFailedCooperation, message: '请输入备注' }],
  mau: [{ required: true && props.type !== 'view', message: '请输入OPR票数' }],
  committedShipment: [{ required: isRequired, message: '请输入OCR票数' }],
  committedSaleAmount: [{ required: isRequired, message: '请输入OCR金额' }],
  competitionSituation: [{ required: true, message: '请输入竞对情况' }],
  customerSituation: [{ required: true, message: '请输入客户情况' }],
  required: [{ required: true, message: '请输入' }]
})
const { resetFields, clearValidate } = useForm(dataForm, formRules)
watch(() => props.originalStatus,
  (val) => {
    const currentStatus = props.originalStatus
    console.log(currentStatus)
    if (currentStatus === null || currentStatus === undefined) {
      return
    }
    switch (props.type) {
      case 'view':
        businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === currentStatus)
        // businessStatusEnumFilter.value = businessStatusEnum.map((item) => ({ ...item, disabled: props.type === 'add' && item.value === 6 }))
        break
      case 'edit':
        // 编辑的时候，状态只能往下选
        // 未能合作6或者未来机会8 不受控制
        if (currentStatus === 6 || currentStatus === 8) {
          businessStatusEnumFilter.value = businessStatusEnum.map((item) => ({ ...item, disabled: item.value === 5 || item.value === 7 }))
        } else if (currentStatus === 7) {
          // 如果商机状态7达成承诺业务量，则不可变更为其他状态（新版【达到承诺业务量】商机状态可以变更为【不能合作】与【未来机会】）
          businessStatusEnumFilter.value = businessStatusEnum.map((item) => ({ ...item, disabled: item.value !== 6 && item.value !== 8 }))
        } else if (currentStatus === 9) {
          // 准备发件
          businessStatusEnumFilter.value = businessStatusEnum.map((item) => ({ ...item, disabled: item.value < 5 || item.value === 5 || item.value === 7 }))
        } else {
          // 其余状态只可以向后变更
          businessStatusEnumFilter.value = businessStatusEnum.map((item) => ({ ...item, disabled: item.value < currentStatus || item.value === 5 || item.value === 7 }))
        }
        break
    }
  })
watch(
  () => dataForm.value.status,
  (val) => {
    isFailedCooperation.value = val === 6
    isRequired.value = (val === 4 || val === 9 || val === 5 || val === 7) && props.type !== 'view'
    setTimeout(() => clearValidate(['failedCooperateId', 'remark']), 0)
  },
  { immediate: true }
)

const handleProductNameChange = (value: number[]) => {
  // dataForm.productName = value[0]
}
const validate = () => {
  return new Promise((resolve, reject) => {
    formRef.value?.validate()
      .then(async (res: any) => {
        resolve(res)
      }).catch((err: any) => {
        reject(err)
      })
  })
}

defineExpose({ resetFields, validate, clearValidate })
</script>
<script lang="ts">
export default { name: 'DetailViewForm' }
</script>

<style scoped></style>
